import { render, staticRenderFns } from "./form16.vue?vue&type=template&id=60047d5e&scoped=true&lang=html"
import script from "./form16.vue?vue&type=script&lang=js"
export * from "./form16.vue?vue&type=script&lang=js"
import style0 from "./form16.vue?vue&type=style&index=0&id=60047d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60047d5e",
  null
  
)

export default component.exports